<template>
  <div class="gridClass my-16">
    <div class="">
      <h3 class="text-center text-2xl font-bold mb-10">
        {{ info.title }}
      </h3>
      <table class="text-center mt-10 w-full shadow bg-gray-200 p-10 mb-6">
        <tbody
          class="[&>tr>td]:py-3 [&>tr>td]:border [&>tr>td]:border-slate-200 [&>tr>td]:text-sm text-sm"
        >
          <tr v-for="item in info.items">
            <td>{{ item }}</td>
          </tr>
        </tbody>
      </table>
      <ul class="list-disc ms-5 text-xs">
        <li v-for="item in info.desc">
          {{ item }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
defineProps({
  info: {
    type: Object,
    required: true,
  },
});
</script>
